export const FORMATS = [
  'pdf',
  'doc',
  'docx',
  'epub',
  'html',
  'md',
  'odp',
  'odt',
  'ods',
  'ppt',
  'pps',
  'ppsx',
  'pptx',
  'rtf',
  'mobi',
  'txt',
  'xls',
  'xlsx',
]

export const AUDIO_FORMATS = [
  'mp3',
  'wav',
  'm4a',
  'flac',
  'ogg',
  'aac',
  'webm',
]

export const ALL_SUPPORTED_FORMATS = [...FORMATS, ...AUDIO_FORMATS]
